module.exports = __webpack_public_path__ + "static/skills-b7945dfa1b49b1f35fa31008df7ee6d2.svg";